import { COMPANY } from './company';

export const kvkk = {
  tr: {
    title: 'KVKK Aydınlatma Metni',
    intro: `6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, ${COMPANY.website} web sitesini ziyaret eden ve bizimle iletişime geçen kişilerin kişisel verilerinin hangi kapsamda işlendiğini aşağıda açıklıyoruz.`,
    sections: [
      {
        heading: '1. Veri Sorumlusu',
        body: [
          `Kişisel verileriniz, veri sorumlusu sıfatıyla ${COMPANY.name} ("MRK Digital") tarafından işlenmektedir.`,
          `Adres: ${COMPANY.address.tr} · E-posta: ${COMPANY.email}`,
        ],
      },
      {
        heading: '2. İşlenen Kişisel Veriler',
        items: [
          'Kimlik bilgileri: ad, soyad.',
          'İletişim bilgileri: e-posta adresi, telefon numarası.',
          'Müşteri işlem bilgileri: şirket adı, mesaj içeriği, görüşme / randevu talepleri.',
          'İşlem güvenliği bilgileri: IP adresi, tarayıcı ve cihaz bilgileri, erişim kayıtları.',
          'Pazarlama bilgileri: çerez tercihleri ve yalnızca onay vermeniz halinde analitik / reklam çerezleri aracılığıyla elde edilen veriler.',
        ],
      },
      {
        heading: '3. Kişisel Verilerin İşlenme Amaçları',
        items: [
          'İletişim ve görüşme taleplerinizi yanıtlamak, randevu planlamak.',
          'Danışmanlık hizmetlerine ilişkin teklif ve sözleşme süreçlerini yürütmek.',
          'Web sitesinin güvenliğini sağlamak, kötüye kullanımı ve spam gönderimleri önlemek.',
          'Yasal yükümlülükleri yerine getirmek ve yetkili kurumların taleplerini karşılamak.',
          'Onayınız olması halinde site kullanımını analiz etmek ve hizmetlerimizi geliştirmek.',
        ],
      },
      {
        heading: '4. Hukuki Sebepler',
        body: [
          'Kişisel verileriniz KVKK m.5/2 kapsamında; bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması (c), hukuki yükümlülüğümüzü yerine getirebilmemiz (ç) ve temel hak ve özgürlüklerinize zarar vermemek kaydıyla meşru menfaatlerimiz (f) hukuki sebeplerine dayanılarak işlenir.',
          'Analitik, performans ve reklam çerezleri ise yalnızca KVKK m.5/1 uyarınca açık rızanıza dayanılarak kullanılır.',
        ],
      },
      {
        heading: '5. Toplama Yöntemi',
        body: [
          'Kişisel verileriniz; web sitemizdeki iletişim kanalları, e-posta yazışmaları, Google Takvim üzerinden yapılan randevu talepleri ve çerezler aracılığıyla, otomatik veya kısmen otomatik yollarla elektronik ortamda toplanır.',
        ],
      },
      {
        heading: '6. Kişisel Verilerin Aktarılması',
        body: [
          'Kişisel verileriniz yukarıdaki amaçlarla sınırlı olarak; barındırma ve altyapı sağlayıcılarımıza, e-posta iletim hizmeti sağlayıcımıza ve randevu hizmeti sağlayıcısına (Google) aktarılabilir. Bu sağlayıcıların bir kısmının sunucuları yurt dışında bulunduğundan aktarım KVKK m.9 hükümlerine uygun olarak gerçekleştirilir.',
          'Yasal zorunluluk halinde verileriniz yetkili kamu kurum ve kuruluşlarıyla paylaşılabilir. Verileriniz hiçbir şekilde satılmaz.',
        ],
      },
      {
        heading: '7. KVKK Madde 11 Kapsamındaki Haklarınız',
        items: [
          'Kişisel verilerinizin işlenip işlenmediğini öğrenme ve işlenmişse buna ilişkin bilgi talep etme,',
          'İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,',
          'Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme,',
          'Eksik veya yanlış işlenmişse düzeltilmesini isteme,',
          'KVKK m.7 çerçevesinde silinmesini veya yok edilmesini isteme,',
          'Düzeltme ve silme işlemlerinin aktarıldığı üçüncü kişilere bildirilmesini isteme,',
          'Münhasıran otomatik sistemlerle analiz edilmesi sonucu aleyhinize bir sonucun ortaya çıkmasına itiraz etme,',
          'Kanuna aykırı işleme sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme.',
        ],
      },
      {
        heading: '8. Başvuru Yöntemi',
        body: [
          `Haklarınıza ilişkin taleplerinizi ${COMPANY.email} adresine e-posta göndererek veya ${COMPANY.address.tr} adresine yazılı olarak iletebilirsiniz. Başvurularınız, Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ uyarınca en geç 30 gün içinde ücretsiz olarak sonuçlandırılır.`,
        ],
      },
    ],
  },
  en: {
    title: 'KVKK Information Notice',
    intro: `Under the Turkish Personal Data Protection Law No. 6698 ("KVKK"), this notice explains how we process the personal data of people who visit ${COMPANY.website} or contact us.`,
    sections: [
      {
        heading: '1. Data Controller',
        body: [
          `Your personal data is processed by ${COMPANY.name} ("MRK Digital") as the data controller.`,
          `Address: ${COMPANY.address.en} · Email: ${COMPANY.email}`,
        ],
      },
      {
        heading: '2. Personal Data We Process',
        items: [
          'Identity data: first and last name.',
          'Contact data: email address, phone number.',
          'Customer transaction data: company name, message content, meeting / appointment requests.',
          'Transaction security data: IP address, browser and device information, access logs.',
          'Marketing data: cookie preferences and, only with your consent, data collected through analytics / advertising cookies.',
        ],
      },
      {
        heading: '3. Purposes of Processing',
        items: [
          'Responding to your contact and meeting requests and scheduling appointments.',
          'Managing proposals and contracts for our consultancy services.',
          'Keeping the website secure and preventing abuse and spam.',
          'Fulfilling legal obligations and requests from competent authorities.',
          'With your consent, analysing site usage to improve our services.',
        ],
      },
      {
        heading: '4. Legal Grounds',
        body: [
          'We process your data under Article 5/2 of the KVKK: where it is directly related to establishing or performing a contract (c), to comply with our legal obligations (ç), and for our legitimate interests provided your fundamental rights are not harmed (f).',
          'Analytics, performance and advertising cookies are used only with your explicit consent under Article 5/1.',
        ],
      },
      {
        heading: '5. Method of Collection',
        body: [
          'Your data is collected electronically, by automated or partly automated means, through the contact channels on our website, email correspondence, appointment requests via Google Calendar, and cookies.',
        ],
      },
      {
        heading: '6. Transfer of Personal Data',
        body: [
          'Limited to the purposes above, your data may be shared with our hosting and infrastructure providers, our email delivery provider and our appointment service provider (Google). Some of these providers operate servers abroad, so transfers are carried out in line with Article 9 of the KVKK.',
          'Where legally required, your data may be shared with competent public authorities. We never sell your data.',
        ],
      },
      {
        heading: '7. Your Rights Under Article 11',
        items: [
          'Learn whether your personal data is processed and request information about it,',
          'Learn the purpose of processing and whether it is used accordingly,',
          'Know the third parties in Turkey or abroad to whom it is transferred,',
          'Request correction if it is incomplete or inaccurate,',
          'Request erasure or destruction under Article 7,',
          'Request that corrections and erasures be notified to third parties it was transferred to,',
          'Object to an outcome against you resulting solely from automated analysis,',
          'Claim compensation for damages caused by unlawful processing.',
        ],
      },
      {
        heading: '8. How to Apply',
        body: [
          `You can send requests regarding your rights to ${COMPANY.email} or in writing to ${COMPANY.address.en}. Requests are resolved free of charge within 30 days at the latest, in line with the Communiqué on the Procedures and Principles of Application to the Data Controller.`,
        ],
      },
    ],
  },
};
